// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"128e7a32","452":"a115f451","469":"4a7d8049","787":"cda612ba"}[chunkId] + ".chunk.js";
};